import { render } from "./InputSelectHorizontal.vue?vue&type=template&id=7f81b543&scoped=true"
import script from "./InputSelectHorizontal.vue?vue&type=script&lang=ts"
export * from "./InputSelectHorizontal.vue?vue&type=script&lang=ts"

import "./InputSelectHorizontal.vue?vue&type=style&index=0&id=7f81b543&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7f81b543"

export default script